module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("C")]), _c('span', {
    staticClass: "CT-SC CharOverride-13"
  }, [_vm._v("ONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-9"
  }, [_c('a', {
    attrs: {
      "href": "#/eBook_V2891#_idTextAnchor000"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Beyond the Rivers of Ethiopia")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('a', {
    attrs: {
      "href": "#/eBook_V28917#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Take Me Home to Mama")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V28918#_idTextAnchor002",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Journalist Plus Plus")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V28919#_idTextAnchor003",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("The Zanzibar Chest")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289110#_idTextAnchor004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Feeding the Beast")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289111#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Going Native")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289112#_idTextAnchor006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("The Sound of Freedom in the Air")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289113#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Empty Quarter")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289114#_idTextAnchor008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Lazarus")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289115#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("One Moment, of the Well of Life to Taste")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289116#_idTextAnchor010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Herograms")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289117#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Postscript")])])]), _vm._v(" "), _c('p', {
    staticClass: "BT ParaOverride-10"
  }, [_c('span', {
    attrs: {
      "href": "#/eBook_V289118#_idTextAnchor012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("Acknowledgments")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6727353a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V28914.vue
// module id = 75
// module chunks = 0